import { PostgrestError } from "@supabase/supabase-js";
import toast from "react-hot-toast";

export function handleError(err: Error | PostgrestError) {
  console.error("TOAST ERROR DETAILS", err);
  toast.error(err.message);
}
